import React from "react";
import {
  AiOutlineCloseCircle,
  AiOutlinePlus,
  AiOutlineMinus,
} from "react-icons/ai";
import "./addproductpopup.css";
import { Divider } from "@mui/material";
import { MyContextSupply } from "../../Context";
import { Link } from "react-router-dom";

const AddPopUp = () => {
  const {
    cartItems,
    totalPrice,
    handleAddProduct,
    handleRemoveProduct,
    deleteSingleItem,
    isProductAddPopUpOpen,
    setIsProductAddPopUpOpen,
    toggleRunPath,
  } = MyContextSupply();
  //   console.log(cartItems);
  return (
    <section
      className={`add-product-popup ${
        isProductAddPopUpOpen &&
        cartItems.length !== 0 &&
        "show-add-product-popup"
      }`}
    >
      <div className="add-product-cart-close-section">
        <p>Shopping Cart</p>
        <button onClick={() => setIsProductAddPopUpOpen(false)}>
          <AiOutlineCloseCircle className="btn-close-cart-ani" />
        </button>
      </div>
      <article className="popup-cart-details">
        <div className="popup-cart-details-fixed-height">
          {cartItems.length !== 0 ? (
            <>
              {cartItems?.map((item, index) => {
                const {
                  _id: id,
                  price: { cost },
                  title: { longTitle },
                  url,
                  quantity,
                } = item;

                return (
                  <div key={id}>
                    <div className="popup-cart-details-produt">
                      <img src={url} alt="" className="popup-cart-image" />
                      <div className="popup-title-add-remove-btn">
                        <div className="dis-flex-cart-popup-details">
                          <p>{longTitle}</p>
                          <p style={{ paddingLeft: "15px", color: "#c31432" }}>
                            ${cost}
                          </p>
                        </div>
                        <div className="popupcart-amount-remove">
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <button onClick={() => handleRemoveProduct(item)}>
                              <AiOutlineMinus style={{ marginTop: "2px" }} />
                            </button>
                            <span style={{ margin: "0 5px" }}>{quantity}</span>
                            <button onClick={() => handleAddProduct(item)}>
                              <AiOutlinePlus style={{ marginTop: "2px" }} />
                            </button>
                          </div>
                          <div>
                            <button
                              onClick={() => deleteSingleItem(item)}
                              className="rm-popupcartadd"
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ padding: "10px  5px" }}>
                      <Divider />
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <h1
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              The cart is empty...
            </h1>
          )}
        </div>
        <div className="popup-cart-checkout-section">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h1>Subtotal</h1>
            <h3>${totalPrice}</h3>
          </div>
          <div>
            <Link
              to="/buynow"
              onClick={() => {
                toggleRunPath();
                setIsProductAddPopUpOpen(false);
              }}
            >
              <button className="popup-checkout-btn">Checkout</button>
            </Link>
          </div>
        </div>
      </article>
    </section>
  );
};

export default AddPopUp;
